import type { ReactNode } from "react";

interface MobileStickyCtaProps {
  /** Accessible name for the bar, e.g. "Connect GA4". */
  label: string;
  children: ReactNode;
}

/** Primary action pinned to the thumb zone below the lg breakpoint. The
 *  spacer keeps the last section of the page from sitting under the bar. */
export function MobileStickyCta({ label, children }: MobileStickyCtaProps) {
  return (
    <>
      <div aria-hidden="true" className="h-24 lg:hidden" />
      <div
        role="region"
        aria-label={label}
        className="fixed inset-x-0 bottom-0 z-30 border-t border-neutral-950/5 bg-white/95 px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] shadow-[0_-8px_24px_-12px_rgba(16,24,40,0.18)] lg:hidden"
      >
        <div className="mx-auto max-w-lg">{children}</div>
      </div>
    </>
  );
}
